import OnboardingBanner from "../../common/onboarding-banner/OnboardingBanner.tsx";
import { FormattedMessage, useIntl } from "react-intl";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import SocialStar from "../../../../common/icons/SocialStar.tsx";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { hasPassedDate } from "../../../../common/utils/time.ts";

export default function NewNavBanner() {
  const intl = useIntl();
  const brand = useBrandLoaderData();

  if (hasPassedDate(new Date(2025, 3, 11), 30)) {
    return null;
  }

  const lineItems = [
    {
      text: (
        <FormattedMessage
          defaultMessage="You can now access <strong>My Account</strong> in the top right."
          values={{ strong: (chunks) => <strong>{chunks}</strong> }}
        />
      ),
      enabled: true,
      key: "my-account",
    },
    {
      text: (
        <FormattedMessage
          defaultMessage="<strong>Redeem Code</strong> is now available in the left side navigation bar."
          values={{ strong: (chunks) => <strong>{chunks}</strong> }}
        />
      ),
      enabled: brand.RedeemCode.enabled,
      key: "redeem-code",
    },
  ].filter((item) => item.enabled);

  return (
    <OnboardingBanner
      noMargin
      icon={<SocialStar />}
      title={intl.formatMessage({
        defaultMessage: "What's New",
      })}
      body={
        <ul>
          {lineItems.map((item) => (
            <li key={item.key}>{item.text}</li>
          ))}
        </ul>
      }
      linkText={intl.formatMessage({ defaultMessage: "Got It" })}
      dismissOnClick
      bannerSeenPreferenceKey={UserPreferenceKey.DashboardNewNavBannerDismissed}
    />
  );
}
